var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcBalanceFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#C5FF04"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2024 6.64C14.2561 6.64 14.3089 6.64383 14.3607 6.65074C14.4017 6.65619 14.4419 6.66376 14.4814 6.67327C14.489 6.6751 14.4966 6.67682 14.5041 6.67879C15.0134 6.81213 15.3893 7.2754 15.3893 7.82648C15.3894 8.48167 14.8581 9.01297 14.2029 9.01297H13.1158C12.5724 9.01605 12.1331 9.45726 12.1331 10.0013C12.1331 10.5473 12.5755 10.9899 13.1214 10.9899H14.2024C14.8575 10.99 15.3885 11.521 15.3886 12.1761C15.3886 12.8313 14.8576 13.3626 14.2024 13.3626H13.1214C11.2651 13.3626 9.76011 11.8576 9.76011 10.0013C9.76012 9.65734 9.81196 9.32547 9.90797 9.01297H9.06183V12.1758C9.06179 12.831 8.5305 13.3622 7.87534 13.3622C7.2202 13.3622 6.68889 12.831 6.68886 12.1758V9.01297H5.8063C5.15115 9.01294 4.62012 8.48165 4.62012 7.82648C4.62014 7.17134 5.15116 6.64018 5.8063 6.64015H13.109C13.1132 6.64013 13.1173 6.64 13.1214 6.64H14.2024Z",
    fill: "#101010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcBalanceFigma);
export default __webpack_public_path__ + "static/media/tc-balance-figma.158d1d1b5c42cefdcc9c9dc0b4e21117.svg";
export { ForwardRef as ReactComponent };